import { render } from "./button.vue?vue&type=template&id=037ad3e8&scoped=true&ts=true"
import script from "./button.vue?vue&type=script&lang=ts"
export * from "./button.vue?vue&type=script&lang=ts"

import "./button.vue?vue&type=style&index=0&id=037ad3e8&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037ad3e8"]])

export default __exports__